import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CheckIcon, ClockIcon, FlameIcon } from 'lucide-react';
import { tomos } from '../data/tomos';
export function ProductTomos() {
  return <section className="w-full bg-white px-6 py-20 sm:px-10" data-id="element-105" data-mp="3ar7og27sdduq">
      <div className="mx-auto max-w-6xl" data-id="element-106" data-mp="3assg9k2puiow">
        <h2 className="text-center font-heading text-3xl font-bold text-mint-dark sm:text-4xl" data-id="element-107" data-mp="3fohlo41f2tt4">
          Todo lo que necesitás para sentirte más liviana
        </h2>

        <div className="mt-14 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3" data-id="element-108" data-mp="36okrjmw9d2qo">
          {tomos.map((tomo, index) => {
          const hasBg = Boolean(tomo.imagenFondo);
          return <motion.div key={tomo.numero} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.3,
            delay: index % 3 * 0.06,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col items-center rounded-2xl p-8 text-center shadow-sm" style={hasBg ? {
            border: `2px solid ${tomo.colorBorder}`,
            backgroundImage: `linear-gradient(180deg, rgba(15,23,42,0.4) 0%, rgba(15,23,42,0.72) 100%), url(${tomo.imagenFondo})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          } : {
            border: `2px solid ${tomo.colorBorder}`,
            background: `linear-gradient(180deg, ${tomo.gradientFrom} 0%, #FFFFFF 100%)`
          }} data-id="element-109" data-mp="2wyrqhftqs60o" data-mpi={index}>
                <span className="flex h-12 w-12 items-center justify-center rounded-full" style={hasBg ? {
              backgroundColor: 'rgba(255,255,255,0.2)',
              color: '#FFFFFF'
            } : {
              backgroundColor: `${tomo.colorBorder}1A`,
              color: tomo.colorTextDark
            }} data-id="element-110" data-mp="xd6ex6f3w7wj">
                  <BookOpenIcon className="h-6 w-6" aria-hidden="true" data-id="element-111" data-mp="yerurpsvpjvr" />
                </span>
                <h3 className="mt-4 text-lg font-bold" style={{
              color: hasBg ? '#FFFFFF' : tomo.colorTextDark
            }} data-id="element-112" data-mp="137kzidocks7u">
                  Tomo {tomo.numero}: {tomo.titulo}
                </h3>
                <p className={`mt-3 text-sm font-bold ${hasBg ? 'text-white' : 'text-gray-700'}`} data-id="element-113" data-mp="fhgvw6b5ssgu">{tomo.subtitulo}</p>
                <ul className="mt-5 space-y-2 text-left" data-id="element-114" data-mp="kg0jsc9bcebu">
                  {tomo.bullets.map(bullet => <li key={bullet} className={`flex items-start gap-2 text-[13px] font-bold ${hasBg ? 'text-white' : 'text-gray-500'}`} data-id="element-115" data-mp="pfwm872d3xpa">
                      <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0" style={{
                  color: hasBg ? '#FFFFFF' : tomo.colorBorder
                }} aria-hidden="true" data-id="element-116" data-mp="20tqonl89b6mj" />
                      <span data-id="element-117" data-mp="3gfua28bierhd">{bullet}</span>
                    </li>)}
                </ul>
                <div className="mt-6 flex items-center gap-3 text-xs font-bold" style={{
              color: hasBg ? '#FFFFFF' : tomo.colorTextDark
            }} data-id="element-118" data-mp="3bkoeehsb1yg3">
                  <span className="flex items-center gap-1" data-id="element-119" data-mp="32k9rxf3ludb0">
                    <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-120" data-mp="2xmgmwpe1fpcb" /> {tomo.tiempo}
                  </span>
                  <span aria-hidden="true" data-id="element-121" data-mp="2soou7t5kjz72">·</span>
                  <span className="flex items-center gap-1" data-id="element-122" data-mp="2npbyeiwpzhsc">
                    <FlameIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-123" data-mp="2nr6ki0jq9fy0" /> {tomo.kcal}
                  </span>
                </div>
              </motion.div>;
        })}
        </div>

        <div className="mt-16 text-center" data-id="element-124" data-mp="lyighoz9eoh6">
          <p className="font-heading text-2xl font-bold text-mint-dark sm:text-3xl" data-id="element-125" data-mp="txvh1v9tssnr">245 recetas totales diferentes</p>
          <p className="mt-2 text-base text-gray-500" data-id="element-126" data-mp="ywgi1wwwjgd9">Para desayuno, almuerzo, merienda, cena y postres</p>
        </div>
      </div>
    </section>;
}